import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { AiCoach_Action as AiCoachAction } from '__generated__/graphql-types';

import { toggleChat, toggleFullScreen as toggleFullScreenAction } from 'bundles/ai-course-coach/store/actions';
import type { AnyFunction, HomeView, SendMessageFunc } from 'bundles/ai-course-coach/utils/types';

import type { GlobalState } from '../store/types';
import WidgetLayout from './WidgetLayout';

type Props = {
  senderPlaceHolder: string;
  profileClientAvatar?: string;
  showCloseButton: boolean;
  showFullScreenButton: boolean;
  autofocus: boolean;
  customLauncher?: AnyFunction;
  handleNewUserMessage: SendMessageFunc;
  handleTextInputChange?: (text: string) => void;
  chatId: string;
  handleToggle?: AnyFunction;
  handleFullScreenToggle?: AnyFunction;
  handleNewSession?: () => void;
  homeView?: HomeView;
  loading?: boolean;
  courseId?: string;
};

function Widget({
  handleNewSession,
  senderPlaceHolder,
  profileClientAvatar,
  showCloseButton,
  showFullScreenButton,
  autofocus,
  customLauncher,
  handleNewUserMessage,
  handleTextInputChange,
  chatId,
  handleToggle,
  handleFullScreenToggle,
  homeView,
  loading,
  courseId,
}: Props) {
  const dispatch = useDispatch();
  const { showChat: isWidgetOpened, isFullScreen } = useSelector((state: GlobalState) => ({
    showChat: state.behavior.showChat,
    isFullScreen: state.behavior.isFullScreen,
    dissableInput: state.behavior.disabledInput,
  }));

  const toggleConversation = () => {
    dispatch(toggleChat());
    handleToggle?.(isWidgetOpened);
  };

  const toggleFullScreen = () => {
    dispatch(toggleFullScreenAction());
    handleFullScreenToggle?.(isFullScreen);
  };

  const handleMessageSubmit = (userInput: string, action: AiCoachAction) => {
    if (!userInput.trim()) {
      return;
    }
    handleNewUserMessage(userInput, action);
  };

  return (
    <WidgetLayout
      onToggleConversation={toggleConversation}
      onToggleFullScreen={toggleFullScreen}
      onSendMessage={handleMessageSubmit}
      senderPlaceHolder={senderPlaceHolder}
      profileClientAvatar={profileClientAvatar}
      showCloseButton={showCloseButton}
      showFullScreenButton={showFullScreenButton}
      handleNewSession={handleNewSession}
      autofocus={autofocus}
      customLauncher={customLauncher}
      onTextInputChange={handleTextInputChange}
      chatId={chatId}
      homeView={homeView}
      loading={loading}
      courseId={courseId}
    />
  );
}

export default Widget;
